import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable, of as observableOf} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {MensajeService} from 'src/app/chacra-core';

import {NotificationService} from '../../../../../core/services';
import * as mensajesActions from './mensajes.actions';

@Injectable()
export class MensajesEffects {
  MensajesSecanoLoadRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<mensajesActions.MensajesLoadRequestAction>(
      mensajesActions.MensajesActionTypes.MENSAJES_LOAD_REQUEST
    ),
    switchMap(() => {
      return this.mensajesService.get().pipe(
        map(queryResults => {
          return new mensajesActions.MensajesLoadSuccessAction({
            items: queryResults.items
          });
        }),
        catchError(error =>
          observableOf(
            new mensajesActions.MensajesLoadFailureAction({
              error
            })
          )
        )
      );
    })
  ));
  MensajesAddRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<mensajesActions.MensajesAddRequestAction>(
      mensajesActions.MensajesActionTypes.MENSAJES_ADD_REQUEST
    ),
    map((action: mensajesActions.MensajesAddRequestAction) => action.payload.item),
    switchMap(item => {
      return this.mensajesService.add(item).pipe(
        map(addResult => {
          return new mensajesActions.MensajesAddSuccessAction({
            item: addResult
          });
        }),
        catchError(error =>
          observableOf(
            new mensajesActions.MensajesAddFailureAction({
              error
            })
          )
        )
      );
    })
  ));

  // load
  MensajesFailureEffect$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(
      mensajesActions.MensajesActionTypes.MENSAJES_LOAD_FAILURE,
      mensajesActions.MensajesActionTypes.MENSAJES_ADD_FAILURE
    ),
    map(
      (
        action:
          | mensajesActions.MensajesLoadFailureAction
          | mensajesActions.MensajesAddFailureAction
      ) => action.payload.error
    ),
    tap((error: string) => this.notificationService.error(error))
  ), {dispatch: false});

  // add

  constructor(
    private notificationService: NotificationService,
    private mensajesService: MensajeService,
    private actions$: Actions,
  ) {
  }
}
